// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7389a934","182":"5e4304c3","457":"b38be56b","551":"62daed32","851":"1328ba56"}[chunkId] + ".chunk.js";
};